import React, { Component } from "react";
import CustomCheck from "./CustomCheck";
import HtmlMapper from "../../../../Common/Helpers/HtmlMapper";
/**
 * 
 */
class ControlEtiqueta extends Component {
    constructor(props) {
        super(props);

        this.state = { tipoElemento: HtmlMapper.ObtenerTipoElemento(props.control.TipoCodigo) }
        /*Bindings*/
        this.calcularWidth = this.calcularWidth.bind(this);
        this.onControlChange = this.onControlChange.bind(this);
        this.generarOptions = this.generarOptions.bind(this);
        this.generarControlSelect = this.generarControlSelect.bind(this);
        this.generarControlCustomCheck = this.generarControlCustomCheck.bind(this);
        this.generarControlDate = this.generarControlDate.bind(this);
        this.validarOptionActiva = this.validarOptionActiva.bind(this);
    }

    render() {
        const { control, esAltaInstancia } = this.props;
        let componente = null, msjOptionActiva;
        let deshabilitarComponente = !esAltaInstancia && control?.Solo_Lectura;


        if (this.state.tipoElemento.esSelect) {
            componente = this.generarControlSelect(control, deshabilitarComponente);
            msjOptionActiva = !this.validarOptionActiva(control.entidadRelacionada, componente, control.Valor) ? "El valor del atributo no está activo actualmente - puede mantenerlo o modificarlo por otro activo." : "";
        }

        if (this.state.tipoElemento.esInputCheck) {
            componente = this.generarControlCustomCheck(control, deshabilitarComponente);
        }

        if (this.state.tipoElemento.esInputText) {
            componente = this.generarControlInput(control, deshabilitarComponente);
        }

        if (this.state.tipoElemento.esInputDate) {
            componente = this.generarControlDate(control, deshabilitarComponente);
        }

        return <div className="row bottom-separator-xs">
            <div className="col-xs-12">
                {!this.state.tipoElemento.esInputCheck &&
                    <label className="labelPropiedadesNuevaInstanciaParametro">{control.Descripcion}</label>}

                {(control.Obligatorio == true) && !this.state.tipoElemento.esInputCheck &&
                    <label className="label-secondary left-separator-xxxs">*</label>}
            </div>

            <div className="col-xs-12">
                {componente}
                {(control.Obligatorio == true) && this.state.tipoElemento.esSelect && msjOptionActiva &&
                    <label className="label-secondary left-separator-xxxs">{msjOptionActiva}</label>}
            </div>

            {(control.esValido == false) && <div className="col-xs-12">
                <label className="error">{control.mensajeError}</label>
            </div>}
        </div>
    }

    /**
     * 
     * @param {any} event
     */
    onControlChange(event) {
        const { control } = this.props;
        const { value } = event.target;

        this.props.actualizarParametro(control.Codigo, value);
    }
    /**
     * 
     */
    calcularWidth() {
        const { control } = this.props;

        let widthCalculado = control.CantidadCaracteres;

        if (widthCalculado > 100) {
            widthCalculado = 100;
        } else {
            if (!widthCalculado) {
                widthCalculado = 25;
            } else {
                if (widthCalculado < 9) {
                    widthCalculado = 25;
                }
            }
        }

        if (widthCalculado == 10) {
            widthCalculado = 12;
        }

        return (widthCalculado + "%");
    }
    /**
     * 
     * @param {any} entidadRelacionada
     */
    generarOptions(entidadRelacionada, esEdicion, ValorOriginal) {
        let resultado = [];
        let elemento = {};
        let elementoAGuardar = {};
        let ACTIVO;
        // entidadRelacionada.forEach((er, index, arrayOri) => {
        //     var guardarAlFinal = false;

        //     if ((er.EsInicioIteracion && index > 0) || (index == arrayOri.length - 1)) {
        //         guardarAlFinal = true;
        //         elementoAGuardar = JSON.parse(JSON.stringify(elemento));
        //     }

        //     elemento.Id = ((er.Codigo == "ID") ? er.Valor : elemento.Id);
        //     elemento.Descripcion = ((er.Codigo == "DESCRIPCION") ? er.Valor : elemento.Descripcion);
        //     elemento.Codigo = ((er.Codigo == "CODIGO") ? er.Valor : elemento.Codigo);

        //     if (guardarAlFinal) {
        //         resultado.push(
        //             <option value={elemento.Id}
        //                 data-codigo={elementoAGuardar.Codigo}>{elementoAGuardar.Descripcion}
        //             </option>
        //         );
        //     }
        // });

        // se cambia logica para la cargo de los combos
        // se valida que antes de cargar cada elemento en el combo estan llenos los 3 valores necesarios para el insert
        // 
        entidadRelacionada.forEach((er, index, arrayOri) => {

            elemento.Id = ((er.Codigo == "ID") ? er.Valor : elemento.Id);
            elemento.Descripcion = ((er.Codigo == "DESCRIPCION") ? er.Valor : elemento.Descripcion);
            elemento.Codigo = ((er.Codigo == "CODIGO") ? er.Valor : elemento.Codigo);
            ACTIVO = er.ACTIVO;

            if (elemento.Id != null && elemento.Descripcion != null && elemento.Codigo != null) {
                if (esEdicion) {
                    if (ACTIVO || elemento.Id == ValorOriginal) {
                        resultado.push(
                            <option value={elemento.Id}
                                data-codigo={elemento.Codigo}>{elemento.Descripcion}
                            </option>
                        );
                    }
                } else {
                    if (ACTIVO) {
                        resultado.push(
                            <option value={elemento.Id}
                                data-codigo={elemento.Codigo}>{elemento.Descripcion}
                            </option>
                        );
                    }
                }
                elemento = {};
            }
        });

        return resultado;
    }
    /**
     * 
     * @param {any} control
     */
     componentDidMount(){
        $('[data-toggle="tooltip"]').tooltip();
    }

    generarControlSelect(control, deshabilitarComponente) {
        let estiloDeshabilitado = deshabilitarComponente ? " NuevaInstanciaParametro-DeshabilitarComponente-SoloLectura" : "";

        return <select className={"form-control" + estiloDeshabilitado} onChange={this.onControlChange} value={control.Valor}>
            {/*Se modifica el valor del "Seleccione..." a "-1" para integrar el valor "Todos/as" al combo - AD17-1349 */}
            <option value="-1">Seleccione...</option>
            {control.PermiteTodos ?
            <option value="0">{control.GeneroEntidadRelacionada == 1 ? "Todos" : "Todas"}</option>
            : null
            }
            {!control.PermiteTodos && control.Valor == "0" ?
            <option value="0">{control.GeneroEntidadRelacionada == 1 ? "Todos" : "Todas"}</option>
            : null
            }
            {this.generarOptions(control.entidadRelacionada || [], control.EntidadInstanciaId, control.Valor)}
        </select>
    }
    /**
     * 
     * @param {any} control
     */
    generarControlCustomCheck(control, deshabilitarComponente) {
        let estiloDeshabilitado = deshabilitarComponente ? " NuevaInstanciaParametro-DeshabilitarCheckbox-SoloLectura" : "";
        let backgroundColor = deshabilitarComponente ? " NuevaInstanciaParametro-DeshabilitarCheckbox-SoloLectura-BackgroundColor" : "";

        return <CustomCheck control={control} onControlChange={this.onControlChange} customCheckStyle={estiloDeshabilitado} backgroundColorCheckLabel={backgroundColor}/>
    }
    /**
     * 
     * @param {any} control
     */
    generarControlInput(control, deshabilitarComponente) {
        let clase = "form-control";

        if (control.esValido == false) {
            clase = "form-control default-input-error";
        }

        let estiloDeshabilitado = deshabilitarComponente ? " NuevaInstanciaParametro-DeshabilitarComponente-SoloLectura" : "";

        return <input className={clase + estiloDeshabilitado}
        
            value={control.Valor || ""}
            type={this.state.tipoElemento.tipo}
            maxLength={control.CantidadCaracteres}
            style={{ width: this.calcularWidth() }}
            onChange={this.onControlChange}
            data-toggle="tooltip" 
            data-placement="right" 
            title={control.Tooltip ? control.Tooltip : null} />
            
    }

    /**
 * 
 * @param {any} control
 */
    generarControlDate(control, deshabilitarComponente) {
        let clase = "form-control";

        if (control.esValido == false) {
            clase = "form-control default-input-error";
        }

        let estiloDeshabilitado = deshabilitarComponente ? " NuevaInstanciaParametro-DeshabilitarComponente-SoloLectura" : "";

        return <input className={clase + estiloDeshabilitado}

            value={control.Valor || ""}
            placeholder={"Formato válido DD-MM-AAAA"}
            type={this.state.tipoElemento.tipo}
            maxLength={control.CantidadCaracteres}
            style={{ width: 25 + '%' }}
            onChange={this.onControlChange} />
    }

    validarOptionActiva(entidadRelacionada, componente, valorOriginal) {
        let elementoActivo = true;
        if(valorOriginal){
            entidadRelacionada.forEach((er, index) => {
                let optionSeleccionada, descSeleccionada, optionSeleccionadaAux;
                let ACTIVO, desc;

                desc = ((er.Codigo == "DESCRIPCION") ? er.Valor : "");
                ACTIVO = er.ACTIVO;

                optionSeleccionadaAux = componente && componente.props.children;

                optionSeleccionadaAux = optionSeleccionadaAux && optionSeleccionadaAux.length >= 3 ? optionSeleccionadaAux[3] : [];

                descSeleccionada = optionSeleccionadaAux && optionSeleccionadaAux.length > 0 && 
                                        optionSeleccionadaAux.filter(x=>x.props.value == valorOriginal);

                descSeleccionada = descSeleccionada.length > 0 ? descSeleccionada[0].props.children : "";

                if(descSeleccionada == desc & descSeleccionada != "" & desc != ""){
                    elementoActivo = ACTIVO;
                }
            });
        }
        return elementoActivo;
    }
}

export default ControlEtiqueta